module.exports = __webpack_public_path__ + "media/images/undraw/shift/contact_us-2ee8c07abfe7e66afb4b0de12565e92e.png";